import NewAccidentContainer from "../../accident/newAccident/newAccidentContainer";

const ArtNewAccidentContainer = () => (
  <NewAccidentContainer selectProvider />
);

export default ArtNewAccidentContainer;
